import { useState } from 'react';
import './Documents.scss';
import DownloadBox from './components/DownloadBox';
import Filter from './components/Filter';

export default function Documents() {
  const [activeFilters, setActiveFilters] = useState<string[]>(['All']);
  console.log(activeFilters);
  return (
    <div className='client-hub-documents'>
      <div className='title'>
        <h1>Documents</h1>
      </div>
      <div className='filters'>
        <Filter name='All' setActiveFilters={setActiveFilters} />
        <Filter name='Game Sheets' setActiveFilters={setActiveFilters} />
        <Filter name='Certificates' setActiveFilters={setActiveFilters} />
        <Filter name='Integration' setActiveFilters={setActiveFilters} />
      </div>
      <div className='documents'>
        {/* <DownloadBox name='download all' activeFilters={activeFilters} type='All' file='' /> */}
        <DownloadBox
          name='Ascend arena 3d game sheet'
          activeFilters={activeFilters}
          type='Game Sheets'
          file='/Ascend Arena 3D Game Sheet.pdf'
        />
        <DownloadBox
          name='Ascend arena 2d game sheet'
          activeFilters={activeFilters}
          type='Game Sheets'
          file='/Ascend Arena 2D Game Sheet.pdf'
        />
        {/* <DownloadBox
          name='ftn arena game sheet'
          activeFilters={activeFilters}
          type='Game Sheets'
          file='https://backendapist.blob.core.windows.net/images/Tokacity%20FTN%20Gamesheet_NEW_compressed.pdf'
        />
        <DownloadBox
          name='favela skybots game sheet'
          activeFilters={activeFilters}
          type='Game Sheets'
          file='https://backendapist.blob.core.windows.net/images/Tokacity%20FTN%20Gamesheet_NEW_compressed.pdf'
        /> */}
        <DownloadBox
          name='bound in gold game sheet'
          activeFilters={activeFilters}
          type='Game Sheets'
          file='https://backendapist.blob.core.windows.net/images/Tokacity%20FTN%20Gamesheet_NEW_compressed.pdf'
        />
      </div>
    </div>
  );
}
